






























































































import { BankSelectModalVue } from "fs-pb-vue2/vueModels/settings/BankSelectModalVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox }
})
export default class BankSelectModal extends BankSelectModalVue {
  async mounted(): Promise<void> {
    await this.init();
    if (!this.OperationModel.banksList || this.OperationModel.banksList.length === 0)
      this.destroyForm();
  }

  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

  get styleForContainer(): string {
    return this.isInit ? this.isMobileBrowser ? 'overflow-y: scroll; height: 300px;' : 'overflow-y: scroll; height: 450px;' : ''
  }
}
